import { GridColDef } from "@mui/x-data-grid-pro";
import { DefaultSwitchInput } from "../../../../../../common/components/default_switch_input";

import DefaultInput from "../../../../../../common/components/default_input";

/**
 * GenerateFornecedorQualificacaoColumnDefinition
 */

type Props = {
  onActionToggleQualificacao: (idQualificacao: number, value: boolean) => void;
  onActionObservacaoChange: (idQualificacao: number, value: string) => void;
};

export const GenerateFornecedorQualificacaoColumnDefinition = ({
  onActionToggleQualificacao,
  onActionObservacaoChange,
}: Props): GridColDef[] => {
  return [
    {
      field: "grupo",
      filterable: false,
      headerName: "Grupo",
      minWidth: 200,
      sortable: false,
    },
    {
      field: "qualificado",
      filterable: false,
      headerName: "Qualificado?",
      minWidth: 125,
      sortable: false,
      valueGetter: (_, row) => ([row['idQualificacao'], row['qualificado']]),
      renderCell: ({ value: [idQualificao, qualificado] }) => {
        return (
          <div className="size-full flex flex-col justify-center items-center">
            <DefaultSwitchInput
              name={`qualificado-${idQualificao}`}
              activeLabel="Sim"
              inactiveLabel="Não"
              value={qualificado}
              onChange={v => onActionToggleQualificacao(idQualificao, v)}
            />
          </div>
        );
      }
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Qualificação",
      flex: 1,
      minWidth: 150,
      sortable: false,
      valueGetter: (_, row) => ([row['idQualificacao'], row['descricao'], row['possuiObservacao'], row['observacao']]),
      renderCell: ({ value: [idQualificacao, descricao, possuiObservacao, observacao] }) => {
        return (
          <div className="w-full flex flex-col py-1 px-2 gap-2">
            <span>{descricao}</span>
            {
              possuiObservacao === true &&
              <DefaultInput
                name={`qual-desc-${idQualificacao}`}
                value={observacao}
                onChangeValue={e => onActionObservacaoChange(idQualificacao, e)}
              />
            }
          </div>
        )
      }
    },
  ];
}